export function initSingleInteractions() {
    const headerImg = document.querySelector('.single .headimg img');
    const iframes = document.querySelectorAll('article.single iframe, article.single .video iframe');

    // Nothing there.
    if (!headerImg && !iframes.length) return;

    // --- Resize iframes to 16:9 ratio ---
    function resizeIframes() {
        iframes.forEach((iframe) => {
            // Skip Instagram or anything that shouldn’t be forced
            const isInstagram = iframe.classList.contains('instagram');
            const hasAllowFullscreen = iframe.hasAttribute('allowfullscreen');

            if (!isInstagram && hasAllowFullscreen) {
                iframe.style.width = '100%';
                iframe.style.height = `${iframe.offsetWidth / 16 * 9}px`;
            }
        });
    }

    // --- Animate header image opacity and position on scroll ---
    function updateHeaderImage() {
        if (!headerImg) return;

        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const header = document.querySelector('#header');
        const headerHeight = header ? header.offsetHeight : 0;
        const imgHeight = headerImg.offsetHeight;
        const totalHeight = imgHeight + headerHeight;

        // Parallax effect (GPU-accelerated via will-change: transform in CSS)
        headerImg.style.transform = `translateY(${scrollTop * 0.35}px)`;

        // Fade out on scroll
        headerImg.style.opacity = `${1 - scrollTop / totalHeight}`;
    }

    // Initial run
    resizeIframes();
    updateHeaderImage();

    // --- Event listeners ---
    window.addEventListener('resize', resizeIframes);
    window.addEventListener('scroll', updateHeaderImage);
}